<nb-card>
	<nb-card-body class="overflow-visible">
		<form class="general-company-info-form" [formGroup]="form">
			<text-area [placeholder]="'company-general-info.description-placeholder' | translate" [htmlPrefix]="'company-description_'" [label]="'company-general-info.description-label' | translate"
					   [autoGrowEnabled]=true
					   [controlName]="'companyDescription'" [description]="companyDescriptionHint | translate" [form]="form" [formKey]="product.standard.name" [formService]="formService"></text-area>
			@if (translationExists('companyDescription')) {
				<translation-field [standard]="product.standard.name" [translationSubject]="'companyDescription'" [translatedText]="getTranslationText('companyDescription')"
								   [previewMode]="true"></translation-field>
			}
			<div class="flex-gap"></div>

			<employees-input [form]="form" [label]="'company-general-info.employee-count-label' | translate" [idPrefix]="'total-employees'" [standard]="product.standard.name"
							 [controlName]="'employeesCount'"
							 [connectedEmployeesControl]="'employeesWithinScope'" [isClientInput]="isClient">
			</employees-input>
			<div class="flex-gap"></div>

			<binary-question-with-comment display-in-one-line="iso \d{4,}" regex-flags="i" [form]="form" [formService]="formService" [formKey]="product.standard.name"
										  [binaryQuestionHtmlID]="'scope-description-needs-narrowing-'"
										  [binaryQuestionControlName]="'scopeDescriptionNeedsNarrowing'" [textAreaHtmlID]="'scope-description-'" [textAreaControlName]="'scopeDescription'"
										  [textAreaPlaceHolder]="'company-general-info.text-area-placeholder-scope'" [autoGrowEnabled]="true" [question]=scopeDescriptionQuestion>
			</binary-question-with-comment>
			@if (translationExists('scopeDescription')) {
				<translation-field [standard]="product.standard.name" [translationSubject]="'scopeDescription'" [translatedText]="getTranslationText('scopeDescription')"
								   [previewMode]="true"></translation-field>
			}
			<div class="flex-gap"></div>

			<company-scope [clientCountry]="order.clientCountry" [product]="product" [allScopes]="allScopes" [form]="form" [isClientInput]="isClient"></company-scope>
			<div class="flex-gap"></div>

			@if (iso9001Product && showCatastrophicRisk()) {
				<binary-question [form]="form" [formService]="formService" [formKey]="product.standard.name" [htmlIdPrefix]="'catastrophic-risk'" [controlName]="'catastrophicRisk'"
								 [question]="'company-general-info.catastrophe-question' | translate">
				</binary-question>
				<div class="flex-gap"></div>
			}

			@if (showPartEmployee()) {
				<binary-question-with-comment [binaryQuestionHtmlID]="'part-time-employees-included'" [binaryQuestionControlName]="'partTimeEmployeesIncluded'"
											  [textAreaHtmlID]="'employees-count-description'"
											  [textAreaControlName]="'employeesCountDescription'" [textAreaPlaceHolder]="'company-general-info.text-area-placeholder-employee'" [form]="form"
											  [formKey]="product.standard.name"
											  [formService]="formService" [autoGrowEnabled]="true"
											  [question]="employeesCountDescriptionQuestion">
				</binary-question-with-comment>
				@if (translationExists('employeesCountDescription')) {
					<translation-field [standard]="product.standard.name" [translationSubject]="'employeesCountDescription'" [translatedText]="getTranslationText('employeesCountDescription')"
									   [previewMode]="true"></translation-field>
				}
				<div class="flex-gap"></div>
			}

			<shifts-number [standard]="product.standard.name" [form]="form" [formService]="formService"></shifts-number>
		</form>
	</nb-card-body>
</nb-card>
